import type { MarketsApi } from "@/v2/api/metadata/markets";
import type { OutcomesApi } from "@/v2/api/metadata/outcomes";
import type { SportsApi } from "@/v2/api/metadata/sports";
import type { BackofficeContext } from "@/v2/framework/context/types";
import { createAddDialog } from "./add";
import { createDeleteDialog } from "./delete";
import { createEditDialog } from "./edit";

export function createDialogs(options: {
  ctx: BackofficeContext;
  marketsApi: MarketsApi;
  sportsApi: SportsApi;
  outcomesApi: OutcomesApi;
}) {
  return {
    add: createAddDialog(options),
    delete: createDeleteDialog(options),
    edit: createEditDialog(options),
  };
}
